import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TgBoxes2Module, TgButtons2Module } from '@trademe/tangram';
import { MotorsCannotEditSomethingMessageSectionComponent } from './motors-cannot-edit-something-message-section.component';

@NgModule({
    imports: [
        CommonModule,
        TgBoxes2Module,
        TgButtons2Module
    ],
    declarations: [MotorsCannotEditSomethingMessageSectionComponent],
    exports: [MotorsCannotEditSomethingMessageSectionComponent]
})
export class MotorsCannotEditSomethingMessageSectionModule { }
